import Multilingual from '~~utils/Multilingual';

const localMapping = {
  SECTION_TITLE: {
    'zh-TW': '報名系統',
    en: 'Registration',
  },
  SIDEBAR: {
    BACK: {
      'zh-TW': '返回',
      en: 'Back',
    },
    OVERVIEW: {
      'zh-TW': '概覽',
      en: 'Overview',
    },
    BASIC: {
      'zh-TW': '基本資料',
      en: 'Basic',
    },
    REQUIREMENT: {
      'zh-TW': '報名需求',
      en: 'Registration Columns',
    },
    DOCUMENTS: {
      'zh-TW': '文件上傳',
      en: 'Document Upload',
    },
    FEE: {
      'zh-TW': '報名費用',
      en: 'Registration Fee',
    },
    REVIEW: {
      'zh-TW': '球隊審核',
      en: 'Team Review',
    },
  },
  DATE_RANGE: {
    'zh-TW': '報名期間',
    en: 'Registration Date',
  },
  DATE_RANGE_HINT: {
    'zh-TW': '請以 yyyy/MM/dd HH:mm 格式填寫',
    en: 'Please follow yyyy/MM/dd HH:mm format',
  },
  CODE: {
    'zh-TW': '報名代碼',
    en: 'Registration Code',
  },
  LINK: {
    'zh-TW': '報名連結',
    en: 'Registration Link',
  },
  LINK_PRIVACY: {
    WORDING: {
      'zh-TW': '連結隱私',
      en: 'Link Privacy',
    },
    PUBLIC: {
      'zh-TW': '公開',
      en: 'Public',
    },
    UNLISTED: {
      'zh-TW': '不公開',
      en: 'Unlisted',
    },
    UNLISTED_HINT: {
      'zh-TW': '僅能透過連結開啟',
      en: 'Can only entry by link',
    },
    KEY_REQUIRED: {
      'zh-TW': '上鎖',
      en: 'Key Required',
    },
    KEY_REQUIRED_HINT: {
      'zh-TW': '以 明碼 儲存，請勿使用平常慣用密碼！',
      en: 'Store Without Encode! Do not use usual password!',
    },
    ENTRY_KEY: {
      'zh-TW': '密碼',
      en: 'Password',
    },
  },
  TEAM_STATUS: {
    WORDING: {
      'zh-TW': '球隊狀態',
      en: 'Team Status',
    },

    SIGNED_UP: {
      'zh-TW': '未送審/不通過',
      en: 'Signed Up',
    },

    REVIEW_REQUESTED: {
      'zh-TW': '待審核',
      en: 'Review Requested',
    },
    REVIEW_COMPLETED: {
      'zh-TW': '完成審核/待繳費',
      en: 'Review Completed',
    },
    PAYMENT_CHECK_REQUESTED: {
      'zh-TW': '繳費待確認',
      en: 'Payment Check Request',
    },
    COMPLETED: {
      'zh-TW': '完成',
      en: 'Completed',
    },

    TO_UPDATE: {
      'zh-TW': '更新狀態',
      en: 'Update Status',
    },
  },
  DESCRIPTION: {
    'zh-TW': '報名引文',
    en: 'Registration Description',
  },
  TEAM_LIMIT: {
    'zh-TW': '隊伍數上限',
    en: 'Limit of Team Amount',
  },
  TEAM_DESCRIPTION: {
    'zh-TW': '報名隊伍需求',
    en: 'Requirement of Team',
  },
  CONTENT: {
    'zh-TW': '報名規章',
    en: 'Regulation Content',
  },
  CONTENT_HINT: {
    'zh-TW': '接受 < 25 MB 的 pdf 檔',
    en: 'Accept < 25 MB .pdf file',
  },
  AVATAR_RATIO: {
    WORDING: {
      'zh-TW': '頭貼比例',
      en: 'Avatar Ratio',
    },
    X: {
      'zh-TW': '寬',
      en: 'Width',
    },
    Y: {
      'zh-TW': '高',
      en: 'Height',
    },
  },
  PLAYER_LIMIT: {
    'zh-TW': '每隊球員上限',
    en: 'Players Limit in a Team',
  },
  PLAYER_DESCRIPTION: {
    'zh-TW': '報名球員需求',
    en: 'Requirement of Player',
  },
  REQUIREMENT_DESCRIPTION: {
    'zh-TW': `常見問題提醒：
    1. 普通兩吋大頭照寬高比例為 3.5 : 4.5
    2. 型態 圖檔 為公開資料，獲取連結者不須身分驗證皆能瀏覽
    3. 型態 PDF文件 為非公開資料，讀取需要進行身分驗證，建議個資相關採用此方式儲存
    賽事結束半年後將保留最低限度資料，其餘資料將從平台中移除，如有備份需求請告知我們，將以壓縮檔形式提供備份資料。`,
    en: `FAQ:
    1. Image Column save as public link, everyone with link can access with no requirement
    2. PDF Column save as unpublic file, access file need related permission
    Minmum data will keep half year after the tournament, rest of the data will be deleted. Please tell us if you need the backup, we will send the backup as zip file.`,
  },
  TEAM_COLUMNS: {
    'zh-TW': '球隊資料蒐集',
    en: 'Columns of Team',
  },
  STAFF_TITLES: {
    'zh-TW': '隨隊人員資料蒐集',
    en: 'Titles of Team Staff',
  },
  STAFF: {
    'zh-TW': '隨隊人員',
    en: 'Team Staff',
  },
  PLAYER_COLUMNS: {
    'zh-TW': '球員資料蒐集',
    en: 'Columns of Player',
  },
  CUSTOM_COLUMN: {
    NAME: {
      'zh-TW': '欄位名稱',
      en: 'Column Name',
    },
    HINT: {
      'zh-TW': '欄位提示',
      en: 'Column Hint',
    },
    TYPE: {
      WORDING: {
        'zh-TW': '欄位型態',
        en: 'Column Type',
      },
      TEXT: {
        'zh-TW': '文字',
        en: 'Text',
      },
      DATE: {
        'zh-TW': '日期',
        en: 'Date',
      },
      IMAGE: {
        'zh-TW': '圖檔',
        en: 'Image',
      },
      PDF: {
        'zh-TW': 'PDF 文件',
        en: 'PDF file',
      },
    },
    IS_REQUIRED: {
      'zh-TW': '必填',
      en: 'Is Required',
    },
  },
  DEFAULT_COLUMN: {
    TEAM: {
      CITY: {
        NAME: {
          'zh-TW': '縣市',
          en: 'City',
        },
        HINT: {
          'zh-TW': '球隊所在縣市',
          en: 'Located City',
        },
      },
      NAME: {
        NAME: {
          'zh-TW': '名稱',
          en: 'Name',
        },
        HINT: {
          'zh-TW': '球隊名稱',
          en: 'Team Name',
        },
      },
      ICON: {
        NAME: {
          'zh-TW': '隊徽',
          en: 'Icon',
        },
        HINT: {
          'zh-TW': '正方形解析度 > 512 隊徽',
          en: 'Square Team Icon with > 512 pixel',
        },
      },
      CONTACT_PERSON: {
        NAME: {
          'zh-TW': '聯絡人',
          en: 'Contact Person',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      CONTACT_PHONE: {
        NAME: {
          'zh-TW': '聯絡人電話',
          en: 'Contact Phone',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
    },
    STAFF: {
      TITLE: {
        NAME: {
          'zh-TW': '職稱',
          en: 'Title',
        },
        HINT: {
          'zh-TW': '如：領隊、教練、球經',
          en: 'ex: coach, manager...',
        },
      },
      NAME: {
        NAME: {
          'zh-TW': '姓名',
          en: 'Full Name',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      AVATAR: {
        NAME: {
          'zh-TW': '頭貼',
          en: 'Avatar',
        },
        HINT: {
          'zh-TW': '身分識別用',
          en: 'For Identity',
        },
      },
      NUMBER: {
        NAME: {
          'zh-TW': '背號',
          en: 'Number',
        },
        HINT: {
          'zh-TW': '以數字為主，不得重複',
          en: 'Digit Only, do not duplicate',
        },
      },
      LICENSE: {
        NAME: {
          'zh-TW': '證明文件',
          en: 'License',
        },
        HINT: {
          'zh-TW': '請提供效期內之證明文件',
          en: 'Please provide valid license',
        },
      },
    },
    PLAYER: {
      NAME: {
        NAME: {
          'zh-TW': '姓名',
          en: 'Full Name',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      NUMBER: {
        NAME: {
          'zh-TW': '背號',
          en: 'Number',
        },
        HINT: {
          'zh-TW': '以數字為主，不得重複',
          en: 'Digit Only, do not duplicate',
        },
      },
      AVATAR: {
        NAME: {
          'zh-TW': '頭貼',
          en: 'Avatar',
        },
        HINT: {
          'zh-TW': '身分識別用',
          en: 'For Identity',
        },
      },
      BIRTHDAY: {
        NAME: {
          'zh-TW': '生日',
          en: 'Birthday',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      FIRST_POSITION: {
        NAME: {
          'zh-TW': '主要守位',
          en: 'Main Position',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      SECOND_POSITION: {
        NAME: {
          'zh-TW': '第二守位',
          en: 'Second Position',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      P_HAND: {
        NAME: {
          'zh-TW': '投球用手',
          en: 'Pitching Hand',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
      B_HAND: {
        NAME: {
          'zh-TW': '擊球用手',
          en: 'Batting Hand',
        },
        HINT: {
          'zh-TW': '',
          en: '',
        },
      },
    },
  },
  DEFAULT_STAFF: {
    COACH: {
      'zh-TW': '教練',
      en: 'Coach',
    },
  },
  DOCUMENT: {
    WORDING: {
      'zh-TW': '文件',
      en: 'Document',
    },
    NONE: {
      'zh-TW': '無',
      en: 'None',
    },
  },
  UPLOAD_DOCUMENT: {
    'zh-TW': '上傳文件',
    en: 'Upload Document',
  },
  DOCUMENT_TITLE: {
    'zh-TW': '文件標題',
    en: 'Document Title',
  },
  DOCUMENT_DUPLICATE_TITLE_HINT: {
    'zh-TW': '將覆蓋相同檔名的文件',
    en: 'Going to cover same title document',
  },
  PRINT: {
    WORDING: {
      'zh-TW': '文件列印',
      en: 'Document Print',
    },

    PROGRAM_WORDING: {
      'zh-TW': '秩序冊列印',
      en: 'Program Print',
    },
  },
  FEE: {
    WORDING: {
      'zh-TW': '報名費',
      en: 'Registration Fee',
    },
    CURRENCY: {
      'zh-TW': '幣值',
      en: 'Currency',
    },
    FREE: {
      'zh-TW': '免費',
      en: 'Free',
    },
    DESCRIPTION: {
      'zh-TW': '費用、繳費說明',
      en: 'Fee & Payment Description',
    },
  },
  REVIEW: {
    TEAM: {
      'zh-TW': '球隊',
      en: 'Team',
    },
    STAFF: {
      'zh-TW': '隨隊人員',
      en: 'Staff',
    },
    PLAYER: {
      'zh-TW': '球員',
      en: 'Player',
    },
    IMPORT_TO_TOURNAMENT: {
      'zh-TW': '導入賽事',
      en: 'Import to Tournament',
    },
    IMPORTED_TO_TOURNAMENT: {
      'zh-TW': '已導入賽事',
      en: 'Imported to Tournament',
    },
    IMPORT_HINT: {
      'zh-TW': '導入後的資料將不會與報名資料連動，主辦單位能於 球隊列表 進行後續編輯',
      en: "Imported Data will not linked with registry data anymore, organizer can edit team's data in Team List",
    },
    IMPORTED_COVER_ERROR: {
      'zh-TW': '球隊已導入（如重新導入可能影響已賽紀錄）',
      en: 'Team is imported (Might effect finished game records if import again)',
    },
    IMPORTED_COVER: {
      'zh-TW': '重新導入（覆蓋）',
      en: 'Import Again (Cover)',
    },
    NAME_DUPLICATE_COVER_ERROR: {
      'zh-TW': '已有相同隊名球隊導入（如強制覆蓋可能影響已賽紀錄）',
      en: 'Same name team is imported (Might effect finished game records if force cover)',
    },
    NAME_DUPLICATE_COVER: {
      'zh-TW': '強制覆蓋',
      en: 'Cover Anyway',
    },
    IMPORT_NOW: {
      'zh-TW': '確定導入',
      en: 'Import Now',
    },
  },
  ERROR: {
    DATE_RANGE_FORMAT: {
      'zh-TW': '報名期間請以 yyyy/MM/dd HH:mm 格式填寫',
      en: 'Registration Date should follow yyyy/MM/dd HH:mm format',
    },
    DATE_RANGE_PERIOD: {
      'zh-TW': '結束時間應大於開始時間',
      en: 'End Time should after Start Time',
    },
    TEAM_LIMIT: {
      'zh-TW': '隊伍數上限應為大於 0 的正整數',
      en: 'Team Limit should be positive integer',
    },
    CONTENT: {
      'zh-TW': '報名規章僅接受 < 25 MB 的 pdf 檔',
      en: 'Regulation file only accept < 25 MB .pdf file',
    },
    AVATAR_RATIO: {
      'zh-TW': '頭貼寬高比格式錯誤',
      en: 'Invalid Avatar Ratio format',
    },
    PLAYER_LIMIT: {
      'zh-TW': '球員數上限應為大於 0 的正整數',
      en: 'Player Limit should be positive integer',
    },
    DOCUMENT: {
      'zh-TW': '文件僅接受 < 25 MB 的 pdf 檔',
      en: 'Document only accept < 25 MB .pdf file',
    },
    FEE: {
      'zh-TW': '報名費需為 0 或正值',
      en: 'Registration Fee should be 0 or positive value',
    },
  },
};

const multi = (textCode, lang = '') => {
  return Multilingual(textCode, localMapping, lang);
};
export default multi;
